module.exports = __webpack_public_path__ + "img/GUY.699ea604.svg";